var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoorClosedSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;stroke:#455064;stroke-miterlimit:10;}.cls-1{stroke-width:2.81px;}.cls-2{fill:#455064;}.cls-3{stroke-width:2.58px;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.59,
    y: 9.32,
    width: 64.22,
    height: 81.35,
    rx: 4.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 70.75,
    cy: 31.1,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 70.75,
    cy: 68.9,
    r: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 34.57,
    y: 43.82,
    width: 31.47,
    height: 21.78,
    rx: 2.88
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 50.31,
    cy: 45.33,
    rx: 8.64,
    ry: 13.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 50.53,
    cy: 53.96,
    r: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 49.49,
    y: 53.41,
    width: 2.08,
    height: 4.52
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorClosedSymbol);
export default __webpack_public_path__ + "static/media/door-closed-symbol.a18b481da59315cf44b427ad29a790f9.svg";
export { ForwardRef as ReactComponent };